var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgClock = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1457_8008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.87502 8.7498V4.7248C8.87502 4.4248 8.62502 4.1748 8.32502 4.1748C8.02502 4.1748 7.77502 4.4248 7.77502 4.7248V8.9748C7.77502 9.1248 7.82502 9.2748 7.92502 9.3748L10.7 12.1998C10.8 12.2998 10.95 12.3748 11.1 12.3748C11.25 12.3748 11.375 12.3248 11.5 12.2248C11.725 11.9998 11.725 11.6498 11.5 11.4248L8.87502 8.7498Z",
    fill: "#6B7280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50001 0.875C4.32501 0.875 0.950012 4.3 0.950012 8.5C0.950012 12.7 4.35001 16.125 8.50001 16.125C12.65 16.125 16.05 12.7 16.05 8.5C16.05 4.3 12.675 0.875 8.50001 0.875ZM8.50001 15C4.95001 15 2.05001 12.075 2.05001 8.5C2.05001 4.925 4.95001 2 8.50001 2C12.05 2 14.95 4.925 14.95 8.5C14.95 12.075 12.05 15 8.50001 15Z",
    fill: "#6B7280"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1457_8008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/clock.c46307041a8ef75e4a70fe676d77f2c1.svg";